module.exports = __webpack_public_path__ + "static/media/asbell_macaluso_permuy_larkin_granda.197f57f2.gif";